/**
 * UserSearchBar Component
 *
 * Search input with debouncing for user search
 * Feature: 045-admin-user-tool
 */

import { useState, useEffect } from 'react';

interface UserSearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

export function UserSearchBar({
  onSearch,
  placeholder = 'Search by username or email...',
  debounceMs = 300
}: UserSearchBarProps) {
  const [inputValue, setInputValue] = useState('');

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(inputValue);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [inputValue, debounceMs, onSearch]);

  return (
    <div className="relative">
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-2 pl-10 bg-surface border border-border text-foreground placeholder:text-muted rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
      <svg
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  );
}
